/**
 * @generated SignedSource<<903f69822642f73eb34f282df018ffbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteDeleteContentSubmissionAndElementsInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type DeleteContentSubmissionButton_DeleteMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteDeleteContentSubmissionAndElementsInput;
};
export type DeleteContentSubmissionButton_DeleteMutation$data = {
  readonly Admin: {
    readonly DeleteContentSubmissionAndLearnElements: {
      readonly deleteDeleteContentSubmissionAndElements: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type DeleteContentSubmissionButton_DeleteMutation = {
  response: DeleteContentSubmissionButton_DeleteMutation$data;
  variables: DeleteContentSubmissionButton_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteContentSubmissionButton_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeleteContentSubmissionAndLearnElementsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "DeleteContentSubmissionAndLearnElements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteDeleteContentSubmissionAndElementsPayload",
                "kind": "LinkedField",
                "name": "deleteDeleteContentSubmissionAndElements",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteContentSubmissionButton_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeleteContentSubmissionAndLearnElementsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "DeleteContentSubmissionAndLearnElements",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteDeleteContentSubmissionAndElementsPayload",
                "kind": "LinkedField",
                "name": "deleteDeleteContentSubmissionAndElements",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a1a33764b988684703b16ec4ca71a23a",
    "id": null,
    "metadata": {},
    "name": "DeleteContentSubmissionButton_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteContentSubmissionButton_DeleteMutation(\n  $input: DeleteDeleteContentSubmissionAndElementsInput!\n) {\n  Admin {\n    DeleteContentSubmissionAndLearnElements {\n      deleteDeleteContentSubmissionAndElements(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "62c5476f94f3337fda6c00a8f72ceca2";

export default node;
